import { useInView } from 'react-intersection-observer'

export default function() {
  return useInView({
    threshold: 0,
    triggerOnce: true,
    rootMargin: '60% 0px',
  })
}
